import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

const store = createStore({
  state() {
    return {
      club_id: null,
      proyecto_id: null,
      proyectoActual: null,
      eventoActual: null,
      usuarioActual: null,
      clubActual: null,
    };
  },
  mutations: {
    setclub_id(state, newclub_id) {
      state.club_id = newclub_id;
    },
    setproyecto_id(state, newproyecto_id) {
      state.proyecto_id = newproyecto_id;
    },
    setProyectoActual(state, proyecto) {

      
      //validar que el objeto proyecto no sea nulo
      if (!proyecto || proyecto === null || proyecto === undefined ||Object.keys(proyecto).length === 0) {
        console.error('Proyecto nulo recibido, abortando...');
        return;
      }
      // Convertir Proxy a objeto simple
      const plainProyecto = JSON.parse(JSON.stringify(proyecto));
      state.proyectoActual = plainProyecto;
    },
    setEventoActual(state, evento) {

      //validar que el objeto evento no sea nulo
      if (!evento || evento === null || evento === undefined ||Object.keys(evento).length === 0) {
        console.log('Evento nulo recibido...');
        state.eventoActual = null;

      }else{
        // Convertir Proxy a objeto simple
        const plainEvento = JSON.parse(JSON.stringify(evento));
        state.eventoActual = plainEvento;
      }
    },
    setClubActual(state, club) {
      //validar que el objeto club no sea nulo
      if (!club || club === null || club === undefined ||Object.keys(club).length === 0) {
        console.error('Club nulo recibido, abortando...');
        return;
      }
      // Convertir Proxy a objeto simple
      const plainClub = JSON.parse(JSON.stringify(club));
      state.clubActual = plainClub;
    },
    setUsuarioActual(state, usuario) {
      //validar que el objeto usuario no sea nulo
      if (!usuario || usuario === null || usuario === undefined ||Object.keys(usuario).length === 0) {
        console.error('Usuario nulo recibido, abortando...');
        return;
      }
      // Convertir Proxy a objeto simple
      const plainUsuario = JSON.parse(JSON.stringify(usuario));
      state.usuarioActual = plainUsuario;
    },
    limpiarUsuarioActual(state) {
      state.usuarioActual = null;
    },
    limpiarClubActual(state) {
      state.clubActual = null;
    },
    limpiarProyectoActual(state) {
      state.proyectoActual = null;
    },
    limpiarEventoActual(state) {
      state.eventoActual = null;
    },
  },
  getters: {
    getclub_id(state) {
      return state.club_id;
    },
    getProyectoId(state) {
      return state.proyecto_id;
    },
    getProyectoActual(state) {
      return state.proyectoActual;
    },
    getEventoActual(state) {
      return state.eventoActual;
    },
    getUsuarioActual(state) {
      return state.usuarioActual;
    },
    getClubActual(state) {
      return state.clubActual;
    },
  },
  plugins: [
    createPersistedState({
      key: 'my-app',
      storage: window.localStorage,
      paths: ['club_id', 'proyecto_id', 'proyectoActual', 'eventoActual', 'usuarioActual', 'clubActual'],
    }),
  ],
});

export default store;
